/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".auth-wrapper[_ngcontent-%COMP%]{text-align:center;padding:2rem}.error[_ngcontent-%COMP%]{color:#b00020}"];
export { styles as styles };
